import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Skeleton from '@zenbusiness/zui/Skeleton';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import * as Styled from './ProductBanners.style';

function ProductBanners({ imageUrl, logo, title, description, color = 'blue', loading = false, isAlt = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (loading) {
    return <Skeleton height={isMobile ? 385 : 200} variant="rounded" />;
  }

  return (
    <Styled.Container position="relative" variant="outlined" color={color} className={isAlt ? 'alt' : ''}>
      {imageUrl && <Styled.Image alt="" src={imageUrl} className={isAlt ? 'alt' : ''} />}
      <Styled.BannerContent>
        {logo && (
          <Styled.LogoContainer>
            <SharedAsset alt="" src={logo} />
          </Styled.LogoContainer>
        )}
        {title && (
          <Heading size="xl" wrap="wrap">
            <FormattedMessage id={title} />
          </Heading>
        )}
        {description && (
          <Text size="sm" color="secondary">
            <FormattedMessage id={description} />
          </Text>
        )}
      </Styled.BannerContent>
    </Styled.Container>
  );
}

ProductBanners.propTypes = {
  imageUrl: PropTypes.string,
  logo: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  color: PropTypes.string,
  loading: PropTypes.bool,
  isAlt: PropTypes.bool,
};

export default ProductBanners;
